import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../core/useAuth';

export const SimulatedLogin = () => {
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('user');
  const [password, setPassword] = useState('password');
  const [loginError, setLoginError] = useState<Error | null>(null);

  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo ||
    '/dashboard/hosting';

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setLoginError(null);

    try {
      login({ username, password });
      void navigate(returnTo, { replace: true });
    } catch (error) {
      setLoginError(error as Error);
    }
  };

  return (
    <div>
      <h1>Simulated Login</h1>
      <p>If REACT_APP_OIDC_AUTHORITY is empty, Keycloak will be disabled.</p>

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">User</label>
          <input
            id="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
          />
        </div>

        <div>
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
          />
        </div>

        {loginError && <p role="alert">{loginError.message}</p>}

        <button type="submit">Sign In</button>
      </form>
    </div>
  );
};
